// extracted by mini-css-extract-plugin
export default {"row":"App_row__j5hty","col":"App_col__sq1As"};